import Swiper from 'swiper';
import {Navigation, FreeMode} from 'swiper/modules';

export const initVideoApartments = () => {
	const videoApartments = document.querySelector( 'section.video-apartments' );

	if ( !videoApartments )
	{
		return;
	}

	const btnNext = videoApartments.querySelector( '.swiper-button-next' );
	const btnPrev = videoApartments.querySelector( '.swiper-button-prev' );
	const slidesCount = videoApartments.querySelectorAll( '.swiper ul.cards-list > li' ).length;

	new Swiper( videoApartments.querySelector( '.swiper' ), {
		modules: [Navigation, FreeMode],
		slidesPerView: 'auto',
		spaceBetween: 18,
		freeMode: true,
		navigation: {
			nextEl: btnNext,
			prevEl: btnPrev,
		},
		loop: true,
		breakpoints: {
			1496: {
				spaceBetween: 40,
				loop: slidesCount > 8 ? true : false
			},
			1280: {
				spaceBetween: 36,
				loop: slidesCount > 8 ? true : false
			},
			1024: {
				spaceBetween: 29,
				loop: slidesCount > 6 ? true : false
			},
			636: {
				spaceBetween: 24,
				loop: slidesCount > 4 ? true : false
			}
		}
	} );
};
